import { useEffect, useState } from "react";
import { getCommissionProgressByAgentId } from "../../api/commissionProgressApi";
import GeneralCommissionProgressList from "../common/commission/generalCommissionProgressList";
import { useUser } from "../../context/userContext";
import { Box } from '@mui/material';

const AGENT_COMM_COLUMNS = [
    // Astern Claims base
    'salesId', 'depositDate', 'customer', 'agent', 'coAgent',
    'commission', 'progress', 'custProgress', 'status',
    'productCategory', 'productEnergy',
    'asternDiscount', 'agentDiscount', 'finalPrice',
    'firstPayment', 'firstPaymentDate', 'secondPayment', 'secondPaymentDate',
    // Extra for Agent view
    'repayment',
    'updatedBy', 'updatedOn',
];

export function AgentCommissionProgressList({ commPayType }) {
    const { user } = useUser();
    const [commissionProgressList, setCommissionProgressList] = useState([]);

    const fetchCommissionProgressByAgentId = async (agentId) => {
        try {
            const response = await getCommissionProgressByAgentId(agentId);
            if (response.data) {
                // Match commPayType prefix so DOC tab captures DOC + DOC/2, TOC tab captures TOC + TOC/2, etc.
                setCommissionProgressList(response.data.filter(item => {
                    const t = item?.commissionProgressDto?.commPayType || '';
                    return t === commPayType || t.startsWith(commPayType + '/');
                }));
            }
        } catch (error) {
            console.error("Error fetching commission progress by agent ID:", error);
        }
    };

    useEffect(() => {
        fetchCommissionProgressByAgentId(user?.userId);
    }, [user?.userId, commPayType]);

    const titleMap = {
        PSC: { title: 'Personal PSC', subtitle: 'Your personal sales commission' },
        DOC: { title: 'Downline DOC', subtitle: 'Your downline overriding commission' },
        TOC: { title: 'Team TOC', subtitle: 'Your team overriding commission' },
        MOC: { title: 'Manager MOC', subtitle: 'Your manager overriding commission' },
        MUC: { title: 'Markup MUC', subtitle: 'The mark-up you sold above the list price' },
        RefC: { title: 'RFC', subtitle: 'Your referral commission' },
    };
    const { title, subtitle } = titleMap[commPayType] || { title: commPayType, subtitle: '' };

    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>{title}</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>{subtitle}</p>
            </Box>
            <GeneralCommissionProgressList
                fetchData={commissionProgressList}
                visibleColumns={AGENT_COMM_COLUMNS}
                detailRoute="/commissions/detail"
            />
        </div>
    );
}
